<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="scroll_view">
    <div class="page_home_container">
      <!-- 通告 -->
      <div class="notice_bar_wrap" v-if="noticyItem.new !== 0">
        <van-notice-bar 
          color="#FE7922"
          background="#FFEDEA"
          :scrollable="true"
        >
          <span v-if="noticyItem.new !== 0">数据更新至{{noticyItem.date}}，今日新增{{noticyItem.new}}</span>
        </van-notice-bar>
      </div>
      <!-- banner -->
      <div class="home_swiper_container">
        <van-swipe class="my-swipe" indicator-color="white" autoplay='3000'>
          <van-swipe-item @click="clickBannderHandle">
            <img :src='img1' class='img'>
          </van-swipe-item>
          <van-swipe-item @click="clickLiteratureHandle">
            <img :src='img2' class='img'>
          </van-swipe-item>
        </van-swipe>
        <!-- <div class="logo"></div> -->
        <div class="pv"><div class="pv-item">{{pvData}}人次已浏览</div></div>
      </div>
      <!-- 功能入口 -->
      <div class="main_container">
        <div class="new_swiper" v-if="hospitalNoticeList.length">
          <div class="new_wrap"></div>
          <div class="content_swiper">
            <van-swipe style="height: 100%;" vertical autoplay="2000"  :show-indicators="false">
              <van-swipe-item v-for="(item) in hospitalNoticeList" :key="item.id">
                <div class="hospital_wrap" @click="clickNoticeHandle(item)">
                  <div class="hospital_notice ellipsis_1">{{item.title}}</div> 
                  <div class="new_date">{{item.publish_date}}</div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="function_entry_container">
          <div class="function_item" 
            v-for="item in funcationData" 
            :key="item.id"
            @click="clickFuncatonHandle(item.to)"
          >
            <div class="bg_item_container" :style="{'backgroundImage':`url(${item.imageUrl})`}" v-if="item.type === 'bg_item'">
              <div class="bg_item">
                <div class="title">{{item.title}}</div>
                <div class="f_title">{{item.f_title}}</div>
              </div>
            </div>
            <div class="icon_item_container" v-if="item.type === 'icon_item'">
              <div class="icon">
                <Icon :class-prefix="item.iconClass" />
              </div>
              <div class="icon_item">
                <div class="title">{{item.title}}</div>
                <div class="f_title">{{item.f_title}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 最新报告 -->
      <div class="new_report">
        <Card title="最新报告" :showMore="false">
          <div class="wrapper">
            <div class="report_item" v-for=" item in newReportList" :key="item.id" @click="newReportHandle(item)">
              <div style="flex:1;margin-top:0.16rem;">
                <div class="title">{{item.title}}</div>
                <div class="f_title">{{item.f_title}}</div>
              </div>
              <div class="img_wrap">
                <div class="img">
                  <img :src="item.img" >
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <!-- list 列表 -->
      <div class="list_container">
        <Card title="精选问答推荐" @moreHandle="moreHandle">
          <div class="home_tab">
            <Tab :tabList="tablist" :currentTab="currentTab" @selectTabHandle="selectTabHandle" />
          </div>
          <div class="list_wrap">
            <div class="list_item" v-for="item in questionList" :key="item.id" @click="detailHandle(item)">
              <ICell :dataItem="item" />
            </div>
            <div class="loading_wrap" v-if="loading"><van-loading color="#FE7922" type="spinner" /></div>
          </div>
        </Card>
      </div>
      <div class="foot_wrap">
        <div class="foot_text">*本平台官方认证网址<br> https://assistant-of-fighting-covid-19.hsmap.com</div>
        <div class="foot_text liability" @click="agreementHandle">免责声明 ></div>
      </div>
      <!-- 联系我们 -->
      <div class="connect" @click="connectHandle"></div>
    </div>
    <Back :src="require('../../assets/images/4.png')" @click="clickLiteratureHandle"/>
  </div>
</template>

<script>
import {  mapState } from 'vuex'
import moment from 'moment'
import { Swipe, SwipeItem, Loading, NoticeBar } from 'vant';
import ExpersImage from 'assets/images/expers.png'
import HospitalImage from 'assets/images/hospital.png'
import Card from '@/components/Card'
import Tab from '@/components/Tab'
import ICell from '@/components/ICell'
import { HttpRequest} from 'utils/'
import { statisticalHandle } from 'utils/baseMethods'
export default {
  name:'home',
  data() {
    return {
      funcationData:[
        {
          id:'0001',
          title:'疫情e课',
          f_title:'非新冠患者的疾病知识e课',
          type:'bg_item',
          imageUrl:ExpersImage,
          to:'/expersread'
        },
        {
          id:'0002',
          title:'医院通告',
          f_title:'非冠状肺炎患者就诊须知',
          type:'bg_item',
          imageUrl:HospitalImage,
          to:'/hospitalnotice'
        },
        {
          id:'0003',
          title:'线上问诊',
          f_title:'全国医院问诊集合',
          type:'icon_item',
          iconClass:'iconxianshangwenzhen iconfont icon_xiaozhi',
          to:'/healthadvice'
        },
        {
          id:'0004',
          title:'对话小智',
          f_title:'自动问答机器人',
          type:'icon_item',
          iconClass:'iconduihuaxiaozhi iconfont icon_xiaozhi',
          to:'https://chat.sobot.com/chat/h5/v2/index.html?sysnum=ff8c5dd4ad604393abb1798d81e110af&channelid=6'
        },
      ],
      loading:false,
      tablist:[
        {
          name:'科普知识',
          key:'0',
          value:'科普知识'
        },
        {
          name:'就医指导',
          key:'1',
          value:'就医指导'
        },
        {
          name:'购药指导',
          key:'2',
          value:'购药指导'
        },
        {
          name:'心理疏导',
          key:'3',
          value:'心理疏导'
        }
      ],
      newReportList:[
        {
          id:'001',
          title:"数字化洞察",
          f_title:"非新冠肺炎患者的困境与破局",
          img:require('../../assets/images/new_report1.png'),
          url:"https://mp.weixin.qq.com/s/f1YdozlW8XjmvUUhe8OEsQ"
        },
        {
          id:'002',
          title:"数字化洞察",
          f_title:"助力女性从容应对“新冠次生灾害”",
          img:require('../../assets/images/new_report2.png'),
          url:"https://mp.weixin.qq.com/s/btHZ6AnvXCAEnJbyCajtyA"
        },
      ],
      currentTab:'0',
      questionList:[],
      tag:'科普知识',
      pvData:"",
      hospitalNoticeList:[],
      areaValue:[],
      noticyItem:{
        date:moment(new Date()).format("YYYY-MM-DD"),
        count:0,
        new:0
      },
      img1:require('../../assets/images/bg2.png'),
      img2:require('../../assets/images/bg3.png'),
    }
  },
  components:{
    Card,
    Tab,
    ICell,
    [Loading.name]: Loading,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [NoticeBar.name]:NoticeBar
  },
  computed:{
    ...mapState('location', ['city','province','area']),
  },
  created() {
    document.title = '火石战疫助手'
    var keepActive = sessionStorage.getItem('keep_active')
    if(keepActive) {
      sessionStorage.removeItem('keep_active')
    }
    this.$store.dispatch('location/getLocation')
    this.getNoticyBarData()
    this.getNoticeList()
    this.getPvData()
    this.getData()
  },
  watch:{
    area:{
      handler:function(value){
        if (value.length ){
          this.areaValue = value
          this.getNoticeList()
        }
      },
      deep:true,
      immediate:true
    }
  },
  activated() {
    document.title = '火石战疫助手'
    this.getPvData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await HttpRequest({
        url:'/professional/quizs/',
        params:{
          page:1,
          tag:this.tag
        }
      })
      if(res.results.length) {
        this.questionList = res.results
        this.loading = false
      }
    },
    async getNoticyBarData() {
      const res = await HttpRequest({
        url:'/home_notice/',
      })
      if(res.msg === 'success') {
        this.noticyItem = res
      }
    },
    async getNoticeList() {
      const res = await HttpRequest({
        url:'/professional/hospital_notices/',
        params:{
          page:1,
          county_code:'',
          city_code: this.areaValue[1] ?this.areaValue[1].code + '' :'',
          province_code:this.areaValue[0] ? this.areaValue[0].code + '' : ''
        }
      })
      this.hospitalNoticeList = res.results
    },

    async getPvData() {
      const res = await HttpRequest({
        url:'/professional/home/',
        params:{
          county_code1:'',
          city_code1: this.areaValue[1] ?this.areaValue[1].code + '' :'',
          province_code1:this.areaValue[0] ? this.areaValue[0].code + '' : ''
        }
      })
      if(res.msg === 'success') {
        var regExpInfo = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
        var ret = res.count.toString().replace(regExpInfo, "$1,");
        this.pvData = ret
      }
    },

    selectTabHandle(data) {
      this.currentTab = data.key
      this.tag = data.item.value
      this.questionList = []
      this.getData()
    },

    clickFuncatonHandle(to) {
      if(to.split('?').length === 2) {
        HttpRequest({url:'/professional/chatbot/'})
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          //说明是移动端
          window.open('https://assistant-of-fighting-ncovid-19.sobot.com/chat/h5/v2/index.html?sysnum=ff8c5dd4ad604393abb1798d81e110af&channelid=7')
        } else {
          //说明是pc端
          window.open('https://assistant-of-fighting-ncovid-19.sobot.com/chat/pc/v2/index.html?sysnum=ff8c5dd4ad604393abb1798d81e110af&channelid=3')
        }
      }else {
        this.$router.push(to)
      }
    },
    newReportHandle(item) {
      let { url } = item
      window.open(url)
    },
    clickBannderHandle() {
      let item = {
        api_url:'banner/1/'
      }
      statisticalHandle(item)
      // window.open('https://mp.weixin.qq.com/s/lCeB2-HoNxu5RIQEX3d7yg')
      window.open('https://mp.weixin.qq.com/s/HcPpmLy19pYKXfDYzxq9SQ')
    },
    moreHandle() {
      this.$router.push('/expersread')
    },
    detailHandle(data) {
      this.$router.push(`/expertsdetail?id=${data.id}`)
    },
    connectHandle() {
      window.open('https://yoghurtlyx.mikecrm.com/IkeoGVL')
    },
    agreementHandle() {
      this.$router.push('/agreement')
    },
    clickNoticeHandle(item) {
      window.open(item.url)
    },
    clickLiteratureHandle() {
       let item = {
        api_url:'banner/2/'
      }
      statisticalHandle(item)
      this.$router.push('/literaturehome')
    }
  }
}
</script>